module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "nav-clean"
  }, [_c('div', {
    staticClass: "nav-clean__bg",
    class: {
      'navigation__bg--scrolling': _vm.$route.path === '/contact-us' || _vm.$route.path === '/smile-assessment' || _vm.windowHeight > _vm.waypoint
    }
  }), _c('div', {
    staticClass: "nav-clean__navbar"
  }, [_c('div', {
    staticClass: "nav-clean__item"
  }, [_c('router-link', {
    staticClass: "nav-clean__logo-container",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$_closeMenu($event)
      }
    }
  }, [(_vm.windowWidth > 480) ? _c('Icon', {
    staticClass: "nav-clean__logo",
    attrs: {
      "name": "logo-white"
    }
  }) : _vm._e(), (_vm.windowWidth <= 480) ? _c('Icon', {
    staticClass: "nav-clean__logo",
    attrs: {
      "name": "logo-nav-mobile"
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "nav-clean__item"
  }, [_c('div', {
    staticClass: "nav-clean__buttons"
  }, [_c('div', {
    staticClass: "nav-clean__button",
    class: {
      'nav-clean__button--open': _vm.isOpen
    },
    on: {
      "click": _vm.dropdown
    }
  }, [(!_vm.isOpen) ? _c('span', [_vm._v("Make Appointment")]) : _vm._e(), (_vm.isOpen) ? _c('span', [_vm._v("Close")]) : _vm._e(), _c('div', {
    staticClass: "nav-clean__link"
  }, [_c('div', {
    staticClass: "nav-clean__dropdown",
    staticStyle: {
      "top": "10px"
    }
  }, [_c('a', {
    staticClass: "nav-clean__dropdown-form-link openchair-widget",
    class: {
      "nav-mobile__link--appointment--active": _vm.menu
    },
    domProps: {
      "innerHTML": _vm._s("Schedule Online")
    }
  })]), _c('div', {
    staticClass: "nav-clean__dropdown",
    staticStyle: {
      "top": "41px"
    }
  }, [_c('FunctionButton2', {
    staticClass: "nav-clean__dropdown-form-link",
    attrs: {
      "content": _vm.button,
      "function1": _vm.openModal
    }
  }, [_vm._v("Email Us")])], 1), _c('div', {
    staticClass: "nav-clean__dropdown",
    staticStyle: {
      "top": "72px"
    }
  }, [_c('a', {
    staticClass: "nav-clean__dropdown-form-link",
    attrs: {
      "href": "tel:+14076271187"
    },
    domProps: {
      "innerHTML": _vm._s("Call Us")
    }
  })])])])]), _c('div', {
    staticClass: "nav-clean__hamburger",
    class: {
      'nav-clean__hamburger--active': _vm.$store.state.menu
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "nav-clean__text"
  }, [_c('transition-group', {
    attrs: {
      "name": "crossfade",
      "tag": "div"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.state.menu),
      expression: "!$store.state.menu"
    }],
    key: "menu",
    staticClass: "nav-clean__hamburger-menu"
  }, [_vm._v("Menu")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.menu),
      expression: "$store.state.menu"
    }],
    key: "exit",
    staticClass: "nav-clean__hamburger-exit"
  }, [_vm._v("Exit")])])], 1), _vm._m(0)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-clean__cross"
  }, [_c('span'), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee5a3d8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-clean/navigation-clean.pug
// module id = 604
// module chunks = 1